import { render, staticRenderFns } from "./Dpart.vue?vue&type=template&id=1e0df27e&scoped=true"
var script = {}
import style0 from "./Dpart.vue?vue&type=style&index=0&id=1e0df27e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0df27e",
  null
  
)

export default component.exports